import React from 'react';
import { observer } from 'mobx-react-lite';
import { JobLangGroupModel } from './lang-group.model';
import { Button, Flex, IconButton, Text } from '@radix-ui/themes';
import { AddIcon, ClearIcon } from 'shared/icons';

import { JobLangGroupItem } from './job-lang-group-item';

function JobLangGroupView({ langGroupModel }: { langGroupModel: JobLangGroupModel }) {
   return (
      <Flex className="langs_fields" direction="column" gap="3">
         <JobLangGroupItem
            model={langGroupModel.lngGroupItem1}
            lngOptions={langGroupModel.langOptions}
            lngSkillOptions={langGroupModel.langSkillsOptions}
            required
            action={
               <Button
                  size="3"
                  className="add-messenger-trigger"
                  variant="outline"
                  type="button"
                  onClick={() => langGroupModel.lngGroupItem2.show()}
               >
                  <Text weight="regular" wrap="nowrap">
                     Додати ще
                  </Text>
                  <AddIcon />
               </Button>
            }
         />

         <JobLangGroupItem
            model={langGroupModel.lngGroupItem2}
            lngOptions={langGroupModel.langOptions}
            lngSkillOptions={langGroupModel.langSkillsOptions}
            action={
               <IconButton
                  size="3"
                  type="button"
                  variant="outline"
                  onClick={() => langGroupModel.lngGroupItem2.hide()}
               >
                  <ClearIcon />
               </IconButton>
            }
         />
      </Flex>
   );
}

export const JobLangGroup = observer(JobLangGroupView);
